import httpClient from "./httpClient";

// Ledgers + categories (GeneralAccountController)
export function listAccountCategories() {
  return httpClient.get("/accounts/ledgers/categories").then((res) => res.data.data);
}
export function listLedgers() {
  return httpClient.get("/accounts/ledgers").then((res) => res.data.data);
}
export function createLedger(payload) {
  return httpClient.post("/accounts/ledgers", payload).then((res) => res.data.data);
}
export function updateLedger(id, payload) {
  return httpClient.put(`/accounts/ledgers/${id}`, payload).then((res) => res.data.data);
}
export function deleteLedger(id) {
  return httpClient.delete(`/accounts/ledgers/${id}`).then((res) => res.data);
}

// Vouchers (Receipt/Payment/Contra/Journal — GeneralAccountTransactionController)
export function createVoucher(payload) {
  return httpClient.post("/accounts/vouchers", payload).then((res) => res.data);
}
export function listVouchers(voucherType, fromDate, toDate) {
  return httpClient.get("/accounts/vouchers", { params: { voucherType, fromDate, toDate } }).then((res) => res.data.data);
}
export function getVoucher(trnId) {
  return httpClient.get(`/accounts/vouchers/${trnId}`).then((res) => res.data.data);
}
export function deleteVoucher(trnId) {
  return httpClient.delete(`/accounts/vouchers/${trnId}`).then((res) => res.data);
}

// Reports
export function getTrialBalance(fromDate, toDate) {
  return httpClient.get("/accounts/vouchers/reports/trial-balance", { params: { fromDate, toDate } }).then((res) => res.data.data);
}
export function getLedgerStatement(ledgerId, fromDate, toDate) {
  return httpClient
    .get("/accounts/vouchers/reports/ledger-statement", { params: { ledgerId, fromDate, toDate } })
    .then((res) => res.data.data);
}

export function getJournal(fromDate, toDate) {
  return httpClient.get("/accounts/vouchers/reports/journal", { params: { fromDate, toDate } }).then((res) => res.data.data);
}

export function getUserWiseCollection(fromDate, toDate) {
  return httpClient.get("/accounts/vouchers/reports/user-wise", { params: { fromDate, toDate } }).then((res) => res.data.data);
}

export function getIncomeStatement(fromDate, toDate) {
  return httpClient.get("/accounts/vouchers/reports/income-statement", { params: { fromDate, toDate } }).then((res) => res.data.data);
}

export function listAccountCategoriesForSummary() {
  return httpClient.get("/accounts/ledgers/categories").then((res) => res.data.data);
}

export function getCategorySummary(categoryIds, userNames, fromDate, toDate) {
  const params = new URLSearchParams();
  categoryIds.forEach((id) => params.append("categoryIds", id));
  (userNames || []).forEach((u) => params.append("userNames", u));
  params.append("fromDate", fromDate);
  params.append("toDate", toDate);
  return httpClient.get(`/accounts/vouchers/reports/category-summary?${params.toString()}`).then((res) => res.data.data);
}

export function getBalanceSheet(trnDate) {
  return httpClient.get("/accounts/vouchers/reports/balance-sheet", { params: { trnDate } }).then((res) => res.data.data);
}

export function getCashSummary(fromDate, toDate) {
  return httpClient.get("/accounts/vouchers/reports/cash-summary", { params: { fromDate, toDate } }).then((res) => res.data.data);
}

export function getCashBook(fromDate, toDate, cashLedgerIds) {
  const params = new URLSearchParams();
  params.append("fromDate", fromDate);
  params.append("toDate", toDate);
  cashLedgerIds.forEach((id) => params.append("cashLedgerIds", id));
  return httpClient.get(`/accounts/vouchers/reports/cash-book?${params.toString()}`).then((res) => res.data.data);
}

export function getFundsFlow(year) {
  return httpClient.get("/accounts/vouchers/reports/funds-flow", { params: { year } }).then((res) => res.data.data);
}

export function getIncomeSummary(fromDate, toDate, ledgerId) {
  return httpClient
    .get("/accounts/vouchers/reports/income-summary", { params: { fromDate, toDate, ledgerId } })
    .then((res) => res.data.data);
}

export function listCashEquivalentLedgers() {
  return httpClient.get("/accounts/vouchers/reports/cash-equivalent-ledgers").then((res) => res.data.data);
}

/** Cash & Cash Equivalent only, no Account Receivable — the fee-collection "Paid By" picker's real ledger scope. */
export function listCashOnlyLedgers() {
  return httpClient.get("/accounts/vouchers/reports/cash-only-ledgers").then((res) => res.data.data);
}

/** Income-category ledgers only — the Fee Head/Fee Fine Ledger Setup pickers' real ledger scope. */
export function listIncomeLedgers() {
  return httpClient.get("/accounts/vouchers/reports/income-ledgers").then((res) => res.data.data);
}

// Note: listCashOnlyLedgers (defined above) is category_default_id {102} only —
// digicampusbd's `/general/accounts/report/cash-equivalance/ledger/list`
// (`GeneralAccountReportService.cashEquiValanceLedgerList`). This is the real scope
// for the fee-collection "Paid By" picker, Auto Ledger Setup, and the SSLCommerz
// (OnlineFeeConfig) receipt-ledger picker — all 3 real old-app templates call this
// exact endpoint. listCashEquivalentLedgers is the *different*, wider {102,103} set
// used by `/cash-equivalance/dfps/ledger/list` (Cash Book, Funds Flow, Income Summary,
// Fee Collect Summary) — do not conflate the two despite the similar names.
